<template>
  <AuthPagesTemplate>
    <div
      class="pt-2 d-flex flex-row-reverse justify-content-between w-100"
    >
      <Locale />
      <dark-Toggler class=" d-block" />
    </div>
    <div
      class="px-xl-2 mx-auto "
    >
      <b-card-title
        class="text-center mb-2 font-weight-bolder"
        style="margin-top:70px"
        title-tag="h2"
      >
        {{ $t('crypto_Cabin_Title', {brand_name: getBrandName()}) }}
      </b-card-title>
      <validation-observer
        ref="loginForm"
        #default="{ invalid }"
      >
        <b-form
          class="auth-login-form "
          @submit.prevent="submit"
        >
          <!-- email -->
          <b-form-group
            :label="$t('email')"
            label-for="login-email"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('email')"
              vid="email"
              rules="required|email"
            >
              <b-form-input
                id="login-email"
                v-model="form.email"
                :state="errors.length > 0 ? false : null"
                name="login-email"
                placeholder="abc@example.com"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- forgot password -->
          <b-form-group
            :label="$t('password')"
            label-for="login-password"
          >

            <validation-provider
              #default="{ errors }"
              :name="$t('password')"
              vid="password"
              rules="required"
            >
              <b-input-group

                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="login-password"
                  v-model="form.password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="login-password"
                  :placeholder="$t('password')"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div class="d-flex justify-content-between">
            <label for="login-password">{{ $t('password') }}</label>
            <b-link :to="{ name: 'forgot-password' }">
              <small>
                {{ $t('forgot_password') }}
              </small>
            </b-link>
          </div>
          <b-form-group>
            <div
              class="google-captcha w-100 mt-2 d-flex justify-content-center"
            >
              <vue-recaptcha
                ref="recaptcha"
                class=""
                :sitekey="sitekey"
                :load-recaptcha-script="true"
                :theme="$store.state.appConfig.layout.skin == 'dark' ? 'dark' : ''"
                @expired="onCaptchaExpired"
                @verify="onVerify"
              />
            </div>
          </b-form-group>

          <!-- checkbox -->
          <b-form-group>
            <b-form-checkbox
              id="remember-me"
              v-model="rememberMe"
              name="checkbox-1"
            >
              {{ $t('Remember Me') }}
            </b-form-checkbox>
          </b-form-group>

          <!-- submit buttons -->
          <b-button
            pill
            type="submit"
            variant="primary"
            block
            :disabled="invalid || !form.recaptcha"
            class="mt-4"
          >
            <span v-if="!pending">{{ $t('Sign in') }}</span>
            <b-spinner
              v-else
              small
              type="grow"
            />
          </b-button>
        </b-form>
      </validation-observer>
      <b-card-text
        class="text-center mb-2 mt-4"
      >
        <span>{{ $t('New on our platform?') }}</span>
        <b-link :to="{ name: 'register' }">
          <div
            v-if="!pending"
            class="mt-1 "
            block
            style="height: 80px;"
          >
            <p class="text-decoration-underline font-weight-bold">
              {{ $t('create_account',{brand_name: getBrandName()}) }}
            </p>
          </div>
        </b-link>
      </b-card-text>
    </div>
  </AuthPagesTemplate>
</template>

<script>
/* eslint-disable global-require */
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Login from '@/views/logics/auth/Login'
import AuthPagesTemplate from '../components/authPagesTemplate.vue'

export default {
  components: {
    DarkToggler,
    Locale: () => import(`@/layouts/${process.env.VUE_APP_THEME_NAME}/components/Locale.vue`),
    AuthPagesTemplate,
  },
  mixins: [togglePasswordVisibility, Login],
}
</script>

<style lang="scss">

</style>
